// extracted by mini-css-extract-plugin
export default {"qrCodeModal":"CustomerQrscan_qrCodeModal__H55gb","qrVideo":"CustomerQrscan_qrVideo__i9O9P","qrResult":"CustomerQrscan_qrResult__twTYU"};